/**
 * /cart.js GET deduplication — Shrine, the bundles app, and our own code
 * all call /cart.js simultaneously after a cart mutation. A short-lived
 * response cache (2 s) ensures only one real network request goes out and
 * every caller gets the same data, preventing Shopify 429 rate-limit errors.
 */
(function () {
  if (window.__cartZeroClearInstalled) return;
  window.__cartZeroClearInstalled = true;

  var CART_JS_CACHE_MS = 2000;
  var cartJsCache = null; // { promise, expiresAt }

  function isCartJsGetUrl(url) {
    if (!url || typeof url !== 'string') return false;
    var raw = url.split('?')[0];
    try {
      if (/^https?:\/\//i.test(raw)) raw = new URL(raw).pathname;
    } catch (e) {}
    return /\/cart\.js$/i.test(raw);
  }

  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) ? init.method.toUpperCase() : 'GET';

      if (method === 'GET' && isCartJsGetUrl(url)) {
        var now = Date.now();
        if (cartJsCache && cartJsCache.expiresAt > now) {
          return cartJsCache.promise.then(function (cachedText) {
            return new Response(cachedText, {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            });
          });
        }
        var textPromise = nativeFetch(input, init).then(function (res) {
          if (!res.ok) { cartJsCache = null; throw new Error('/cart.js ' + res.status); }
          return res.text();
        });
        cartJsCache = { promise: textPromise, expiresAt: now + CART_JS_CACHE_MS };
        textPromise.catch(function () { cartJsCache = null; });
        return textPromise.then(function (text) {
          return new Response(text, { status: 200, headers: { 'Content-Type': 'application/json' } });
        });
      }

      return nativeFetch(input, init);
    };
  }

})();
